var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 35,
    viewBox: "0 0 152 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3056_14881)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.1504 13.6907V19.7304C88.1504 22.4292 89.1657 23.8122 91.4142 23.8122C92.2655 23.7962 93.1093 23.6523 93.9166 23.3853V27.7951C92.4812 28.1965 91.0003 28.4181 89.5089 28.4548C84.5971 28.4548 82.3128 25.689 82.3128 21.0816V13.6907H79.5566V9.34436H82.8526L84.2146 5.34375H88.1469V9.34436H93.9487V13.6907H88.1504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5469 18.6112C35.5469 12.9172 39.733 9.08594 45.3096 9.08594C50.8863 9.08594 55.1045 12.9031 55.1045 18.6112C55.1045 24.5027 50.922 28.4539 45.3096 28.4539C39.6972 28.4539 35.5469 24.5027 35.5469 18.6112ZM49.846 18.6782C49.846 15.9476 47.8799 13.972 45.3132 13.972C42.7465 13.972 40.7768 15.9476 40.7768 18.6959C40.7768 21.4935 42.7429 23.5996 45.3096 23.5996C47.8763 23.5996 49.8425 21.4758 49.8425 18.6959L49.846 18.6782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.0508 18.6112C95.0508 12.9172 99.2333 9.08594 104.814 9.08594C110.394 9.08594 114.608 12.9031 114.608 18.6112C114.608 24.5027 110.422 28.4539 104.814 28.4539C99.2047 28.4539 95.0508 24.5027 95.0508 18.6112ZM109.35 18.6782C109.35 15.9476 107.384 13.972 104.817 13.972C102.25 13.972 100.281 15.9476 100.281 18.6959C100.281 21.4935 102.247 23.5996 104.814 23.5996C107.38 23.5996 109.346 21.4758 109.346 18.6959L109.35 18.6782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.445 9.34375L137.772 27.9921H132.51L128.956 16.8264H128.799L125.185 27.9921H120.334L114.689 9.34375H120.227L123.219 20.5906H123.412L126.905 9.34375H131.752L135.209 20.5906H135.398L138.437 9.34375H143.445Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6769 11.735V9.34661H21.8848V13.6929H23.4684V27.9949H29.3132V18.5155C29.5992 15.4886 31.8799 14.402 34.0355 14.402C34.4218 14.4017 34.806 14.4576 35.1758 14.5679V8.97266C32.7056 8.97266 30.6358 9.56534 28.6769 11.735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.862 6.72228C149.483 6.72228 150.09 6.54062 150.606 6.20027C151.122 5.85991 151.524 5.37615 151.762 4.81017C151.999 4.24418 152.061 3.62138 151.94 3.02053C151.819 2.41968 151.52 1.86776 151.081 1.43457C150.642 1.00138 150.083 0.706379 149.474 0.586862C148.865 0.467346 148.234 0.528686 147.661 0.763126C147.087 0.997566 146.597 1.39458 146.252 1.90395C145.907 2.41333 145.723 3.01219 145.723 3.62482C145.723 4.44632 146.054 5.23417 146.643 5.81506C147.231 6.39595 148.03 6.72228 148.862 6.72228ZM144.361 13.6934H145.945V27.9953H151.779V9.34702H144.361V13.6934Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5158 6.72059C75.1366 6.72059 75.7434 6.53893 76.2596 6.19858C76.7757 5.85822 77.178 5.37446 77.4156 4.80847C77.6531 4.24248 77.7153 3.61969 77.5942 3.01884C77.4731 2.41799 77.1741 1.86607 76.7352 1.43288C76.2962 0.999692 75.737 0.704686 75.1281 0.58517C74.5193 0.465653 73.8882 0.526993 73.3147 0.761433C72.7412 0.995874 72.251 1.39288 71.9061 1.90226C71.5612 2.41164 71.3772 3.0105 71.3772 3.62312C71.3772 4.44462 71.7078 5.23248 72.2965 5.81336C72.8851 6.39425 73.6834 6.72059 74.5158 6.72059ZM64.0238 8.68914C64.0238 5.39764 65.3894 4.27931 67.6701 4.27931C68.2944 4.28345 68.9143 4.38343 69.5075 4.57565V0.328092C68.5411 0.111168 67.5531 0.00112584 66.5619 0C61.6466 0 58.415 2.56829 58.415 8.68914V9.34533H55.2441V13.6917H58.415V27.9936H64.2455V13.6917H71.5988V27.9936H77.4328V9.34533H64.0238V8.68914Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4188 9.10156C8.40433 9.10156 6.7921 11.6064 6.7921 11.6064V9.34499H0V13.6913H1.58363V34.9997H7.41411V27.0126C8.92684 27.9407 10.6698 28.4388 12.451 28.4519C17.4235 28.4519 21.1627 24.5713 21.1627 18.8773C21.1627 13.1163 17.2984 9.10156 12.4188 9.10156ZM11.6288 23.6152C9.56613 23.5835 7.1603 22.2041 7.1603 18.842C7.1603 15.7516 9.25155 13.9383 11.6288 13.9383C14.006 13.9383 15.9185 16.0127 15.9185 18.842C15.9185 21.6714 14.0668 23.6152 11.6288 23.6152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.14987 18.843C6.82814 7.74082 21.1523 8.96499 21.1523 18.843L15.1931 16.0525C15.1931 16.0525 14.1207 13.9357 11.4396 13.9357C10.996 13.9779 10.3039 13.9968 9.83097 14.2885C6.97114 16.0524 7.14987 18.843 7.14987 18.843Z",
    fill: "url(#paint0_linear_3056_14881)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9068 19.2291C16.2285 30.3313 1.7864 28.9307 1.7864 19.0526L7.14858 19.7582C7.14858 19.7582 7.50606 23.6389 11.6171 23.6389C15.7281 23.6389 15.9068 19.2291 15.9068 19.2291Z",
    fill: "url(#paint1_linear_3056_14881)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3056_14881",
    x1: 18.5534,
    y1: 21.4184,
    x2: 9.62166,
    y2: 12.3678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00108F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#00108F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3056_14881",
    x1: 4.38526,
    y1: 16.4773,
    x2: 13.3171,
    y2: 25.5279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00108F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#00108F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3056_14881"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 152,
    height: 35,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.f592e3504cb77ecba3ce32dab3be42db.svg";
export { ForwardRef as ReactComponent };